import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addPodcast } from '@/api';
import episodeKeys from '@/queries/episode/episodeKeys';
import camelcaseKeys from 'camelcase-keys';

const transform = (data) => {
    // TODO: Do camelcase transformation in Axios interceptor
    return camelcaseKeys(data, { deep: true });
};

const mutationFn = async ({ showId, name }) => {
    const { data } = await addPodcast(showId, { name });

    return transform(data);
};

const useAddEpisodeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: episodeKeys.allLists() });
        },
    });
};

export default useAddEpisodeMutation;
